import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Games from './components/Games';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('pt'); // Default to Portuguese

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="min-h-screen bg-darker">
      {/* Purple gradient background effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-primary/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute top-1/2 right-0 w-[800px] h-[800px] bg-secondary/15 rounded-full blur-3xl animate-pulse-slow animation-delay-2000"></div>
        <div className="absolute bottom-0 left-1/3 w-[700px] h-[700px] bg-accent/10 rounded-full blur-3xl animate-pulse-slow animation-delay-1000"></div>
      </div>
      
      <div className="relative z-10">
        <Header language={language} onLanguageChange={handleLanguageChange} />
        <Hero language={language} />
        <Features language={language} />
        <Games language={language} />
        <Footer language={language} />
      </div>
    </div>
  );
}

export default App;
